import { motion } from "framer-motion";

export const ease = [0.16, 1, 0.3, 1];

export function FadeUp({ children, delay = 0, className = "", ...rest }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 1, delay, ease }}
      className={className}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

export function MaskReveal({ children, delay = 0, className = "", inView = false }) {
  const motionProps = inView
    ? {
        initial: { y: "110%" },
        whileInView: { y: 0 },
        viewport: { once: true, amount: 0.1 },
      }
    : {
        initial: { y: "110%" },
        animate: { y: 0 },
      };
  return (
    <span className={`reveal-mask ${className}`}>
      <motion.span
        style={{ display: "inline-block" }}
        {...motionProps}
        transition={{ duration: 1.1, delay, ease }}
      >
        {children}
      </motion.span>
    </span>
  );
}

export function Stagger({ children, className = "" }) {
  return (
    <motion.div
      className={className}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
      variants={{
        hidden: {},
        visible: { transition: { staggerChildren: 0.12 } },
      }}
    >
      {children}
    </motion.div>
  );
}

export function StaggerItem({ children, className = "" }) {
  return (
    <motion.div
      variants={{
        hidden: { opacity: 0, y: 24 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.9, ease } },
      }}
      className={className}
    >
      {children}
    </motion.div>
  );
}
